import { useEffect, useState } from "react"

import { IconCaretUpDownFilled } from "@tabler/icons-react"
import { useIsFetching } from "@tanstack/react-query"

import { Spinner } from "@/components/ui"
import { cn } from "@/lib/utils"

interface OpLog {
  op: string
  timestamp: number
  queryCount: number
  queryMillis: number
}
const fmt = new Intl.DateTimeFormat(undefined, {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
}).format

export function LumenDevtools() {
  const fetchCount = useIsFetching()
  const [log, setLog] = useState<OpLog[]>([])
  const [isOpen, setOpen] = useState(true)

  const isXlsx =
    typeof document !== "undefined"
      ? document?.location.pathname.includes("admin/xlsx")
      : false
  const dockLeft = !isXlsx

  useEffect(() => {
    const val: OpLog[] = JSON.parse(sessionStorage.getItem("graphql-log") || "[]")
    setLog(val)
  }, [fetchCount])

  return (
    <div
      className={cn(
        "fixed bottom-0 z-modal flex cursor-pointer flex-col gap-1 rounded-t-md border-2 border-success-300 bg-success-100 p-1 px-2 font-mono text-xs print:hidden",
        { "left-4": dockLeft, "right-0 mr-16": !dockLeft },
        "print:hidden",
      )}
      onClick={() => setOpen(!isOpen)}
    >
      {isOpen && (
        <table className="[&_tr>*]:border-b [&_tr>*]:border-success [&_tr>*:not(:first-child)]:pl-2">
          <thead>
            <tr>
              <th>Time</th>
              <th>Op</th>
              <th>Queries</th>
              <th>Millis</th>
            </tr>
          </thead>
          <tbody>
            {log.slice(-10).map((op, key) => (
              <tr key={key}>
                <td>{fmt(new Date(op.timestamp))}</td>
                <td>{op.op}</td>
                <td>{op.queryCount}</td>
                <td>{op.queryMillis}ms</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div className="flex items-center justify-between gap-1">
        <span className="flex items-center gap-1">
          Fetching: {fetchCount}
          <IconCaretUpDownFilled />
        </span>
        {fetchCount > 0 && <Spinner className="inline" size={14} />}
      </div>
    </div>
  )
}

export function logResponse(response: Response) {
  const op: OpLog = {
    op: response.headers.get("x-graphql-operation") || "",
    queryCount: parseInt(response.headers.get("x-sql-query-count") || ""),
    queryMillis: parseInt(response.headers.get("x-sql-query-millis") || ""),
    timestamp: +new Date(),
  }
  console.info(op)
  const log: OpLog[] = JSON.parse(sessionStorage.getItem("graphql-log") || "[]")
  log.push(op)
  sessionStorage.setItem("graphql-log", JSON.stringify(log.slice(-50)))
}
